import { useTranslation } from "react-i18next";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, ListItemAvatar, ListItemText, TableContainer } from "@mui/material";
import { useEffect, useState } from "react";
import { pad } from "../../functions/default";
import { DateIsXMeasurementOld } from "../../functions/dates";
import { useMessage } from "../../context/message-context";
import { FullPageSpinner } from "../lib";
import apiRequest from "../../functions/api";
import { useSessionStorage } from "../../utils/hooks";
import { useZulassung } from "../../context/zulassungs-context";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";

export function DeleteIllnessAttestationDialog({ reloadHistory, open, setOpen, currentIllnessAttestation, setCurrentIllnessAttestation, meldungsZeitraum }) {
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { zulassung } = useZulassung();
  const { mandant } = zulassung;
  const { t } = useTranslation();
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!open) setCurrentIllnessAttestation(null);
  }, [open]);

  const handleDelete = () => {
    if (
      !currentIllnessAttestation ||
      !currentIllnessAttestation.gemeldetAm ||
      DateIsXMeasurementOld(currentIllnessAttestation.gemeldetAm, "YYYYMMDD", "days") > 7
    )
      return;

    setIsLoading(true);

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant,
      program: "SENDAU",
      statement: "MELDUNG_LOESCHEN",
      habwKey: currentIllnessAttestation.key,
    };

    apiRequest("POST", "daten", payload, headers, dataCb, errorCb);
  };
  const dataCb = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
      if (response.data.message === "ok") {
        showSuccessMessage(t("Löschen erfolgreich."));
        if (reloadHistory) reloadHistory();
        setOpen(false);
      }
    } else {
      setIsLoading(false);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut."));
      }
    }
  };

  const errorCb = () => {
    setIsLoading(false);
  };

  return (
    <>
      <Dialog open={open} maxWidth="md" onClose={() => setOpen(false)} fullWidth>
        <DialogContent>
          <DialogContentText style={{ fontSize: 22, fontWeight: "bold" }}>{t("Meldung wirklich löschen?")}</DialogContentText>
          {currentIllnessAttestation && (
            <Box display="flex" mt={1} alignItems="center">
              <ListItemAvatar>
                <Avatar>{currentIllnessAttestation.artTextKurz}</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={`${currentIllnessAttestation.artText} ${t("vom")} ${currentIllnessAttestation.gemeldetAmText}`}
                secondary={meldungsZeitraum(currentIllnessAttestation)}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button style={{ marginRight: "10px" }} display="flex" onClick={() => setOpen(false)}>
            {t("Abbrechen")}
          </Button>
          <Button color="primary" variant="contained" onClick={() => handleDelete()}>
            {t("Meldung Löschen")}
          </Button>
        </DialogActions>
      </Dialog>
      {isLoading && <FullPageSpinner />}
    </>
  );
}
